export function seo({
  description,
  image,
  keywords,
  title
}: {
  description?: string
  image?: string
  keywords?: string
  title: string
}) {
  const tags = [
    { title },
    { content: description, name: 'description' },
    { content: keywords, name: 'keywords' },
    { content: title, name: 'twitter:title' },
    { content: description, name: 'twitter:description' },
    { content: '@pesonamalangid', name: 'twitter:creator' },
    { content: '@pesonamalangid', name: 'twitter:site' },
    { content: 'website', name: 'og:type' },
    { content: title, name: 'og:title' },
    { content: description, name: 'og:description' },
    { content: 'index, nofollow', name: 'robots' },
    { content: 'index, nofollow', name: 'googlebot' },
    { content: 'https://backoffice.pesonamalang.id/', name: 'og:url' },
    { content: 'Back-office Wisata Malang', name: 'author' },
    { href: 'https://backoffice.pesonamalang.id/', rel: 'canonical' },
    ...(image
      ? [
          { content: image, name: 'twitter:image' },
          { content: 'summary_large_image', name: 'twitter:card' },
          { content: image, name: 'og:image' },
          { content: title, name: 'og:image:alt' }
        ]
      : [])
  ]

  return tags
}
